import React from 'react';

const DrawerContent: React.FC<React.HTMLAttributes<HTMLElement>> = ({ className = '', children, ...props }) => (
  <section className={`linq-drawer-inner-content oo-drawer-main-section ${className}`}>{children}</section>
);

export default DrawerContent;
